// test2404
(2404 && 0);
